import * as React from 'react'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  StyledUserNameAndMainColumn,
  StyledTableRow,
  SubTableHeaderCell,
  SubColumnHeading,
} from '../components'

const UserContractsTableHead = React.memo(() => {
  const { t } = useTranslation()

  return (
    <TableHead
      sx={{
        borderTop: '2px solid',
        color: (theme) => theme.tokens.outlineVariant,
      }}
    >
      <TableRow
        sx={{
          borderBottom: '2px solid ',
          color: (theme) => theme.tokens.outlineVariant,
        }}
      >
        <StyledUserNameAndMainColumn
          style={{
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            color: (theme) => theme.tokens.outlineVariant,
            width: '17%',
          }}
        >
          <Typography variant="h4" align="left" style={{ fontWeight: 'bold' }}>
            {t('LBLUserName')}
          </Typography>
        </StyledUserNameAndMainColumn>
        <StyledUserNameAndMainColumn>
          <Typography variant="h4" align="left" style={{ fontWeight: 'bold' }}>
            {t('LBLContracts')}
          </Typography>
        </StyledUserNameAndMainColumn>
      </TableRow>
      <StyledTableRow
        style={{
          borderBottom: '2px solid',
          color: (theme) => theme.tokens.outlineVariant,
        }}
      >
        <SubTableHeaderCell
          style={{
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            color: (theme) => theme.tokens.outlineVariant,
            width: '17%',
          }}
        />
        <SubTableHeaderCell style={{ width: '14%' }}>
          <SubColumnHeading variant="h4">
            {t('LBLContractsNumber')}
          </SubColumnHeading>
        </SubTableHeaderCell>
        <SubTableHeaderCell style={{ width: '12%' }}>
          <SubColumnHeading variant="h4">{t('LBLLocation')}</SubColumnHeading>
        </SubTableHeaderCell>
        <SubTableHeaderCell style={{ width: '14%' }}>
          <SubColumnHeading variant="h4">{t('LBLPartner')}</SubColumnHeading>
        </SubTableHeaderCell>
        <SubTableHeaderCell style={{ width: '12%' }}>
          <SubColumnHeading variant="h4">
            {t('LBLContractType')}
          </SubColumnHeading>
        </SubTableHeaderCell>
        <SubTableHeaderCell style={{ width: '12%' }}>
          <SubColumnHeading variant="h4">
            {t('LBLcontractStatus')}
          </SubColumnHeading>
        </SubTableHeaderCell>
        <SubTableHeaderCell style={{ width: '19%' }}>
          <div style={{ width: 110 }} />
        </SubTableHeaderCell>
      </StyledTableRow>
    </TableHead>
  )
})

UserContractsTableHead.displayName = 'UserContractsTableHead'

export default UserContractsTableHead
